import MxEmptyCard from "@rf-l1/empty-sections/MxEmptyCard";
import MxLoading from "@rf-l1/loading/MxLoading";

const MxListLoadingTemplate = () => {
  return (
    <MxEmptyCard size="section">
      <MxLoading variant="gradient" />
    </MxEmptyCard>
  );
};

export default MxListLoadingTemplate;
